export function CollectionAnnotationNote({ note }: { note: string | null }) {
  if (!note) return null;

  return (
    <p className="line-clamp-3 border-t border-border/60 pt-2 text-xs leading-relaxed text-muted-foreground">
      {note}
    </p>
  );
}
